import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { ColumnDef } from '@tanstack/react-table';
import { PhoneOutgoing } from 'lucide-react';
import useCallHistory from '@/hooks/useCallHistory';
import { ICall } from '@/types';
import DataTable from '../DataTable/DataTable';
import Time from '../Time';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

interface CampaignAssociationsProps {
  contactId: string;
}

const ContactCallHistory = ({ contactId }: CampaignAssociationsProps) => {
  const callHistory = useCallHistory(contactId as string);
  const data = useMemo(() => callHistory.data || [], [callHistory.data]);
  const campaignDrawer = useModal('campaign-drawer');

  const columns: ColumnDef<ICall>[] = [
    {
      accessorKey: 'campaign.name',
      header: 'Campaign',
      cell: ({ row }: { row: any }) => {
        return (
          <>
            <Button
              variant={'outline'}
              className="py-1.5 rounded-full px-2 text-sm cursor-pointer"
              onClick={() => {
                campaignDrawer.show({ campaign: row.original.campaign });
              }}
            >
              <div className="flex items-center gap-1">
                <PhoneOutgoing />
                {row.original.campaign.name}
              </div>
            </Button>
          </>
        );
      },
    },

    {
      accessorKey: 'created_at',
      header: 'Called',
      cell: ({ row }) => <Time>{row.original.created_at}</Time>,
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row }) => <Badge>{row.original.status}</Badge>,
    },
  ];

  return <DataTable data={data} columns={columns} model={callHistory} placeholder="Search call history..." />;
};

export default ContactCallHistory;
